import { createApi, createDomain } from 'effector';
import { createGate } from 'effector-react';

const domain = createDomain('ui');

export const $uiCategoryShow = domain.store<boolean>(false);
export const $uiCategoryShowApi = createApi($uiCategoryShow, {
  set: (_, bool: boolean) => bool,
});

export const $GateCategoryHeight = createGate<number>({
  domain,
  defaultState: 0,
});
